import { useState, useEffect } from "react";
import { CustomInput, ReactSelect, CheckInput } from "../kits/Inputs/Inputs";
import CustomButton from "../kits/button/CustomButton";
import ToastCustomize from "../kits/ToastCustomize";
import useAxios from "../../services/useAxios";
import { translateToReactSelect } from "../../utils/helperFunction";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import AssEditCustomerModal from "../customer-list/customerModal/AddEditCustomerModal"
import AddEditCustomerModal from "../customer-list/customerModal/AddEditCustomerModal";
export default function CheckPriceComponent({
  data,
  changeData,
  price,
  setPrice,
  reset,
}) {
const { execute: getCustomer } = useAxios("api2/get_customers");
const { loadingUser, execute: findUser } = useAxios("api/Find_users");
const { loadingConfig, execute: getConfig } = useAxios("api2/get_configs");
const { execute: getHashtag } = useAxios("api/Find_tag");
const {execute: sendSms} = useAxios("utility/send_sms");

  const productType = [
    { label: "فلت", value: 1 },
    { label: "باکس", value: 2 },
    { label: "کف کاست", value: 3 },
  ];

  const [garamajList, setGaramajList] = useState([]);
  const [orderCount, setOrderCount] = useState(1000);
  const [mobile, setMobile] = useState();
  const [customerData, setCustomerData] = useState([]);
  const [tagOption, setTagOption] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const [bankName, setBankName] = useState([]);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [customerUpdater, setCustomerUpdater] = useState(false);
  const [tagUpdater, setTagUpdater] = useState(false);
  const [loading, setLoading] = useState(true);
  const [baseContent, setBaseContent] = useState([]);
  const [content, setContent] = useState([]);
  const validation = () => {
    let validate = true;
    let txt = "";
    if (data?.type?.value == undefined || data?.type?.value == -1) {
      txt = "لطفا نوع محصول را وارد کنید.";
      validate = false;
    } else if (
      data?.garamaj == undefined ||
      data?.garamaj == -1 ||
      data?.garamaj == ""
    ) {
      txt = "لطفا گرماژ را وارد کنید.";
      validate = false;
    } else if (
      data?.price == undefined ||
      data?.price == -1 ||
      data?.price == ""
    ) {
      txt = "لطفا قیمت پیشنهادی را وارد کنید.";
      validate = false;
    } else if (
      data?.ghad == undefined ||
      data?.ghad == -1 ||
      data?.ghad == ""
    ) {
      txt = "لطفا قد را وارد کنید.";
      validate = false;
    } else if (data?.arz == undefined || data?.arz == -1 || data?.arz == "") {
      txt = "لطفا عرض را وارد کنید.";
      validate = false;
    } else if (
      data?.type?.value == 2 &&
      (data?.atf == undefined || data?.atf == -1 || data?.atf == "")
    ) {
      txt = "لطفا عطف را وارد کنید.";
      validate = false;
    }

    if (!validate) {
      ToastCustomize({
        mainText: txt,
        duration: 3000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
    }
    return validate;
  };
  const CheckPriceFunc = () => {
    let arzTemp = parseFloat(data?.arz);
    let atfTemp = parseFloat(data?.atf);
    let arzFabricTemp = 0; //عرض طاقه
    let arzBagTemp = 0; //عرض بگ
    let priceTemp = parseFloat(data?.price);
    // let garamajTemp = parseFloat(data?.garamaj?.value);//for react select
    let garamajTemp = parseFloat(data?.garamaj);
    let perProductPrice = 0;
    let additionalPriceTemp = data.additionalPrice;
    let additionalPrice = 0;
    let additionalPriceTotal = 0;
    for (let i = 0; i < additionalPriceTemp.length; i++) {
      if (
        additionalPriceTemp[i].checked &&
        additionalPriceTemp[i]?.priceOnEach
      ) {
        additionalPrice +=
          parseFloat(additionalPriceTemp[i].price) *
          parseFloat(additionalPriceTemp[i].count) *
          additionalPriceTemp[i]?.more_option_value;
      } else if (
        additionalPriceTemp[i].checked &&
        !additionalPriceTemp[i]?.priceOnEach
      ) {
        additionalPriceTotal +=
          parseFloat(additionalPriceTemp[i].price) *
          parseFloat(additionalPriceTemp[i].count) *
          additionalPriceTemp[i]?.more_option_value;
      }
    }
    if (data?.type?.value == 1) {
      arzFabricTemp = (parseFloat(data?.ghad) * 2 + 10) / 100;
      arzBagTemp = (arzTemp + 1) / 100;
      let x = (priceTemp * garamajTemp * arzFabricTemp) / 1000;
      let y = x * arzBagTemp;
      perProductPrice = y + 150;
    } else if (data?.type?.value == 2) {
      arzFabricTemp = (parseFloat(data?.ghad) * 2 + atfTemp + 10) / 100;
      arzBagTemp = (arzTemp + atfTemp + 1) / 100;
      let x = (priceTemp * garamajTemp * arzFabricTemp) / 1000;
      let y = x * arzBagTemp;
      perProductPrice = y + 950;
    } else if (data?.type?.value == 3) {
      arzFabricTemp = ((parseFloat(data?.ghad) + 5) * 2 + 10) / 100;
      arzBagTemp = (arzTemp + 1) / 100;
      let x = (priceTemp * garamajTemp * arzFabricTemp) / 1000;
      let y = x * arzBagTemp;
      perProductPrice = y + 150;
    }

    let priceString = (
      parseFloat(perProductPrice) + parseFloat(additionalPrice)
    ).toString();
    let point = priceString.substring(
      priceString.indexOf(".") + 1,
      priceString.indexOf(".") + 2
    );

    if (point <= 5) {
      setPrice({
        price: Math.floor(
          parseFloat(perProductPrice) + parseFloat(additionalPrice)
        ),
        additionOnAll: additionalPriceTotal,
      });
    } else {
      setPrice({
        price: Math.ceil(
          parseFloat(perProductPrice) + parseFloat(additionalPrice)
        ),
        additionOnAll: additionalPriceTotal,
      });
    }
  };
  const checkMobileValidate =(mobile)=>{
    getCustomer(mobile).then(res=>{
      console.log(res)
      setCustomerData(res.customers[0]);
      if(res.total == 0)
      setShowCustomerModal(true)
    })
  }
  useEffect(() => {
    let tempArray = [];
    for (let i = 60; i <= 150; i += 10) {
      tempArray.push({ label: i, value: i });
    }
    setGaramajList(tempArray);
  }, []);
  useEffect(() => {
    getHashtag().then((result) => {
      setTagOption(translateToReactSelect(false, result, "text"));
      // console.log("###", result);
      // console.log(
      //   "translateToReactSelect",
      //   translateToReactSelect(false, result, "text")
      // );
    });
  }, [tagUpdater]);
  // addCommas(price?.price)} </span>تومان
  // </div>
  // <div>
  //   قیمت کل
  //   <span className="mx-1">
  //     {addCommas(
  //       parseInt(price?.price) * parseInt(orderCount) +
  //         price?.additionOnAll
  const handleSendSms = ((mobile)=>{
    let checkAdditional = false;
    let message = `محصول ${data?.type?.label} با مشخصات گرماژ ${data?.garamaj} ، قد ${data?.ghad}، عرض ${data?.arz} `;
    if(data.atf ){
      message += `، عطف ${data?.atf} ، `
    }
    data?.additionalPrice.map(e =>{

      if(e?.checked)
        checkAdditional = true
    });
    if(checkAdditional)
      message += "و هزینه های جانبی :"
    data?.additionalPrice.map(e =>{
      if(e?.checked)
        message += `${e?.title} ،`
    })
    message += ` به قیمت ${addCommas(price?.price)} تومان و مجموع ${addCommas(
      parseInt(price?.price) * parseInt(orderCount) +
        price?.additionOnAll
    )} تومان`;
    sendSms({message , mobile}).then(res =>{
      setMobile('')
      ToastCustomize({
        mainText: "پیام با موفقیت ارسال شد",
        duration: 3000,
        toastType: "success",
        color: "success",
        position: "top-center",
        hasHeader: false,
      });
    }).catch(err =>{
      ToastCustomize({
        mainText: "ارسال پیغام با خطا مواجه شد!",
        duration: 3000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
    });

  })
  useEffect(() => {
    findUser().then((result) => {
      setUserOption(translateToReactSelect(false, result, "fullname", true));
    });
    getConfig().then((result) => {
      setBankName(result.banks);
      async function loadpage() {
        await getCustomer().then((data) => {
          setContent(data.customers.reverse());
          setBaseContent(data.customers.reverse());

          setLoading(false);
        });
      }
      loadpage();
    });
  }, [customerUpdater]);
  // console.log("dataCheckPrice", price);
  return (
    <div className="d-flex flex-wrap m-2 border rounded p-3 shadow">
      <div
        className=" px-1 flex-grow-1 col-6 col-sm-4 col-lg-2"
        //  style={{ width: 100 }}
      >
        <ReactSelect
          title="نوع محصول"
          itemsList={productType}
          placeholder="..."
          inputValue={data?.type}
          onChangeFunc={(e) => {
            changeData({ type: e }, "normal");
            setPrice(-1);
          }}
        />
      </div>
      <div
        className=" px-1 flex-grow-1 col-6 col-sm-4 col-lg-2"
        // style={{ width: 100 }}
      >
        {/* <ReactSelect
          title="گرماژ"
          itemsList={garamajList}
          placeholder="..."
          inputValue={data?.garamaj}
          onChangeFunc={(e) => changeData({ garamaj: e }, "normal")}
        /> */}
        <CustomInput
          label="گرماژ"
          inputValue={data?.garamaj}
          onChangeFunc={(e) => {
            if (!isNaN(e.target.value))
              changeData({ garamaj: e.target.value }, "normal");
          }}
        />
      </div>
      <div
        className=" px-1 flex-grow-1 col-6 col-sm-4 col-lg-2"
        // style={{ width: 150 }}
      >
        <CustomInput
          label="قیمت پیشنهادی پارچه"
          inputValue={addCommas(data?.price)}
          onChangeFunc={(e) => {
            if (!isNaN(removeCommas(e.target.value)))
              changeData({ price: removeCommas(e.target.value) }, "normal");
          }}
        />
      </div>
      {data?.type?.value == 2 && (
        <div
          className=" px-1 flex-grow-1 col-6 col-sm-4 col-lg-2"
          // style={{ width: 100 }}
        >
          <CustomInput
            label="عطف بگ (cm)"
            inputValue={data?.atf}
            onChangeFunc={(e) => {
              if (!isNaN(e.target.value))
                changeData({ atf: e.target.value }, "normal");
            }}
          />
        </div>
      )}
      <div
        className=" px-1 flex-grow-1 col-6 col-sm-4 col-lg-2"
        // style={{ width: 100 }}
      >
        <CustomInput
          label="قد بگ (cm)"
          inputValue={data?.ghad}
          onChangeFunc={(e) => {
            if (!isNaN(e.target.value))
              changeData({ ghad: e.target.value }, "normal");
          }}
        />
      </div>
      <div
        className=" px-1 flex-grow-1 col-6 col-sm-4 col-lg-2"
        // style={{ width: 100 }}
      >
        <CustomInput
          label="عرض بگ (cm)"
          inputValue={data?.arz}
          onChangeFunc={(e) => {
            if (!isNaN(e.target.value))
              changeData({ arz: e.target.value }, "normal");
          }}
        />
      </div>

      {/* <div className=" px-1" style={{ width: 100 }}>
        <CustomInput
          label="تعداد"
          inputValue={data?.count}
          onChangeFunc={(e) => {
            if (!isNaN(e.target.value)) changeData({ count: e.target.value });
          }}
        />
      </div> */}
      <div className="w-100">
        {data?.additionalPrice?.map((v, i) => {
          return (
            <div
              className="d-flex flex-wrap align-items-center my-2 py-1"
              style={{ borderBottom: `1px dashed lightgray` }}
            >
              <div style={{ width: 200 }}>
                <CheckInput
                  key={`corporate-customer-1-${v.price}`}
                  label={`${v.title} - ${addCommas(v.price)}`}
                  type="checkbox"
                  id={`corporate-radio-1-${v.price}`}
                  name={`corporate-radio-`}
                  onChangeFunc={() => {
                    changeData({}, "checkbox", v.id);
                  }}
                  inputValue={v.checked}
                />
                <p
                  className="ms-3"
                  style={{ color: "#677788", fontSize: "0.75rem" }}
                >
                  {v?.description ?? ""}
                </p>
              </div>
              <div
                className="d-flex align-items-center mx-1"
                style={{ width: 150 }}
              >
                {v?.more_option &&
                  v?.more_option?.map((vv) => {
                    return (
                      <CheckInput
                        key={`corporate-customer-${v.id}-${vv.title}`}
                        label={`${vv.title}`}
                        type="radio"
                        id={`corporate-radio-${i}-${vv.title}-${vv.value}`}
                        name={`corporate-radio-${v.id}-${vv.title}`}
                        onChangeFunc={() => {
                          changeData(
                            { more_option_value: vv?.value },
                            "countCheckbox",
                            v.id
                          );
                        }}
                        inputValue={
                          v?.more_option_value == vv?.value ? true : false
                        }
                        inputContainer="mx-1"
                      />
                    );
                  })}
              </div>
              {v.needNumber && (
                <div
                  className="ms-2 d-flex align-items-center"
                  style={{ width: 300 }}
                >
                  <label className="me-2" style={{ fontSize: 12 }}>
                    {v?.numberTitle}
                  </label>
                  <CustomInput
                    inputSize="sm"
                    style={{ width: 100 }}
                    inputValue={v.count}
                    onChangeFunc={(e) => {
                      if (!isNaN(e.target.value))
                        changeData(
                          { count: e.target.value },
                          "countCheckbox",
                          v.id
                        );
                    }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div
        className=" px-1 mt-2 col-6 col-md-2"

        // style={{ width: 150 }}
      >
        <CustomInput
          label="تعداد بگ"
          inputValue={orderCount}
          onChangeFunc={(e) => {
            if (!isNaN(e.target.value)) setOrderCount(e.target.value);
          }}
        />
        
      </div>

      {price != -1 && (
        <div className=" w-100 mt-2 d-flex">
          <div
            className="bg-secondary text-light p-2 rounded"
            style={{ fontSize: 14, minWidth: 200, lineHeight: 1.5 }}
          >
            <h5 className="fw-bold my-1">قیمت پیشنهادی</h5>
            <div>
              {" "}
              قیمت تک
              <span className="mx-1">{addCommas(price?.price)} </span>تومان
            </div>
            <div>
              قیمت کل
              <span className="mx-1">
                {addCommas(
                  parseInt(price?.price) * parseInt(orderCount) +
                    price?.additionOnAll
                )}
              </span>
              تومان
            </div>
          </div>
        </div>
      )}
      
      <div className="w-100 d-flex justify-content-end mt-3">
        <CustomButton
          className=""
          onClick={() => {
            if (validation()) CheckPriceFunc();
          }}
          color="primary"
        >
          استعلام
        </CustomButton>
        <CustomButton
          className="mx-1"
          onClick={() => {
            reset();
            setOrderCount(1000);
          }}
          color="orange"
        >
          خالی شدن لیست
        </CustomButton>
      </div>
      {price != -1 && (
        <div className="w-100 "
        style={{borderTop: "1px dashed lightgray",marginTop: "0.5rem"}}
       >
        <span style={{fontSize:"13px" }}>ارسال پیامک</span>
        <div className="d-flex align-items-center">
       <div
          className=" px-1 mt-2 col-xl-2 col-md-3  "
          // style={{ width: 150 }}
        >
          <CustomInput
            label=" شماره تماس"
            inputValue={mobile}
            onChangeFunc={(e) => {
              if(e.target.value.length < 12)
                if (!isNaN(e.target.value)) setMobile(e.target.value);
            }}
          />
         
          
        </div>
        <CustomButton
            className="mx-2"
            style={{marginTop: "30px"}}
            onClick={() => {
              checkMobileValidate({mobile});
            }}
            color="primary"
          >
            ارسال
          </CustomButton>
  
        </div>
        {mobile != "" && <div style={{display: customerData == undefined || customerData.length == 0 ? "none" : "flex",alignItems:"center", marginTop:"20px",fontSize:"14px",paddingTop: "0.5rem",marginTop: "0.5rem"} }>
          {customerData?.corporate == "1" && (
            <div style={{marginLeft:"20px"}}>
              <span>نام شرکت: </span>
              <span>{customerData?.company_name}</span>
            </div>
          )}
            <div style={{marginLeft:"14px"}}>
              <span>نام مشتری:  </span>
              <span>{customerData?.firstname} {customerData?.lastname}</span>
            </div>
            <CustomButton
            className="mx-2"
            // style={{margin: "14px"}}
            onClick={() => {
              handleSendSms(mobile);
            }}
            color="success"
          >
            تایید
          </CustomButton>
        </div>}
        {
          customerData == undefined && 
          <AddEditCustomerModal
              type="add"
              headerText="افزودن مشتری"
              show={showCustomerModal}
              setShow={setShowCustomerModal}
              tagOption={tagOption}
              userOption={userOption}
              bankName={bankName}
              setCustomerUpdater={setCustomerUpdater}
              setTagUpdater={setTagUpdater}
            />
        }
       </div>
      )}
    </div>
  );
}
